import { useEffect } from 'react'

// Copies each table's header text into data-label on its body cells, so
// responsive-tables.css can show "Label: value" when rows turn into cards on
// narrow screens; the "Action(s)" column is flagged with data-actions. Runs
// for every list page rendered inside the container, including rows added
// later by fetching, filtering or paging.
const labelTables = (root) => {
  root.querySelectorAll('.table-responsive table').forEach((table) => {
    const headers = [...(table.tHead?.rows?.[0]?.cells ?? [])].map((cell) => cell.textContent.trim());
    if (headers.length === 0) return;

    [...table.tBodies].forEach((body) => {
      [...body.rows].forEach((row) => {
        [...row.cells].forEach((cell, index) => {
          const label = headers[index] ?? '';
          if (cell.dataset.label !== label) cell.dataset.label = label;
          if (/^actions?$/i.test(label)) cell.dataset.actions = '';
        });
      });
    });
  });
};

const useResponsiveTables = (containerRef) => {
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return undefined;

    labelTables(root);
    // Only childList is observed, so writing data-label does not retrigger it.
    const observer = new MutationObserver(() => labelTables(root));
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [containerRef]);
};

export default useResponsiveTables
